/*
==============================
Impacto video
==============================
*/
$(function() {
    if ($('.impacto-video video') && $('.impacto-video video').length > 0) {
        if (isMobile.any()) {
            $('.impacto-video video').remove();
            $('.impacto-video .img-block').css({
                height: '100%',
                width: '100%'
            }).children('img').centrarImagenVertical();
            onGlobalResize();
        }
        else {
            $('.impacto-video').each(function() {
                var $impacto = $(this),
                    $video = $impacto.find('video'),
                    DOMvideo = $video.get(0),
                    sources = [
                        {file: $video.data('mp4'), type: 'mp4'},
                        {file: $video.data('ogg'), type: 'ogg' },
                        {file: $video.data('webm'), type: 'webm' }
                    ];

                for (var i = 0; i < sources.length; i++) {
                    if (typeof sources[i].file != "undefined") {
                        $video.append('<source src="'+ sources[i].file + '" type="video/' + sources[i].type + '">');
                    }
                }

                $video.append('Your browser does not support the video tag.');

                DOMvideo.autoplay = true;
                DOMvideo.load();
                DOMvideo.oncanplaythrough = function() {
                    $impacto.find('.img-block').hide();
                    DOMvideo.play();
                };
            });
        }
    }
});